module.exports = __webpack_public_path__ + "static/media/workshop_0002.48b40946.png";